// API client for the Assessment leaderboard (GET /api/assessment/leaderboard).
//
// Envelope: { data: { entries, myEntry }, isError, statusCode, errorMessage }.
// - scope: ALL | COURSE | COLLEGE | WEEKLY. COURSE requires courseId.
// - `entries` is one page (the backend ranks everything in memory then slices
//   by page/size) and the response carries NO total count, so callers must
//   infer "has more" from a full page.
// - `myEntry` and COLLEGE scope are relative to the *calling user* (the token's
//   user id). An admin has no ranking and usually no college, so for admins
//   `myEntry` is null and COLLEGE returns an empty list.
// - Students need >= 3 completed attempts in scope to be ranked at all.
import api from "../axiosInstance";

export { apiErrorMessage } from "./assessmentHierarchy";

export const LEADERBOARD_SCOPES = [
  { value: "ALL", label: "All" },
  { value: "COURSE", label: "Exam" },
  { value: "COLLEGE", label: "My College" },
  { value: "WEEKLY", label: "Weekly" },
];

// -> { entries: [{ rank, studentUserId, studentName, collegeName, avgPercentage, avgAccuracy }], myEntry }
export const getLeaderboard = async ({ scope, courseId, page = 0, size = 20 }) => {
  const params = { scope, page, size };
  if (courseId) params.courseId = courseId;
  const res = await api.get("/api/assessment/leaderboard", { params });
  const data = res.data?.data || {};
  return { entries: data.entries || [], myEntry: data.myEntry || null };
};
